/**
 * LoadingIndicator.js
 * Created by calhosh on 11/6/2019.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@ey/canvascoreservices/LoadingIndicator';
import Utility from '../../../util/utilityfunctions';

export default function LoadingIndicator({show, fullscreen, view, styleName, tip, variant, size}) {
	return (
		<>
			<Loader
				show={show}
				fullscreen={fullscreen}
				view={view}
				styleName={styleName}
				tip={tip}
				variant={variant ? variant : 'circular'}
				size={size}
				theme={Utility.getTheme()}
			/>
		</>
	);
}

LoadingIndicator.propTypes = {
	show: PropTypes.bool,
	fullscreen: PropTypes.bool,
	view: PropTypes.string,
	styleName: PropTypes.string,
	indicatorType: PropTypes.string,
	label: PropTypes.string,
	remFontSize: PropTypes.string,
	size: PropTypes.string
	/**
	 * One of 'xs' | 'sm' | 'md' | 'lg' | 'xl'
	 */
};
